// Scrolling Text Animation
document.addEventListener('DOMContentLoaded', function() {
  const scrollingTextSection = document.querySelector('.scrolling-text');

  if (!scrollingTextSection) return;

  // The CSS animation handles the scrolling
  // This JavaScript is here for any future enhancements
  // such as dynamic speed adjustments or interaction features
});